// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header_23gJL","header__icon":"header__icon_3pBs3","header__title":"header__title_2Bl3J","header__close":"header__close_Hrbqb"};